import {
  EventPreparationEventDetail,
  EventPreparationEventDetailsSportFactory,
} from './types'

export function eventPreparationEventDetailsAmericanFootballFactory(): EventPreparationEventDetailsSportFactory {
  function getDetails(): EventPreparationEventDetail[] {
    return []
  }

  return { getDetails }
}
